var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalIconWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_14)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C16 23.1634 23.1634 16 32 16H100C108.837 16 116 23.1634 116 32V100C116 108.837 108.837 116 100 116H32C23.1634 116 16 108.837 16 100V32Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.4907 83.3625L32.3907 50.3956C32.1834 49.895 32.0487 49.3578 32 48.8083C32.0089 48.43 32.0975 48.0632 32.2561 47.7216C32.4147 47.3796 32.6344 47.0624 32.9152 46.8059C33.1961 46.5499 33.5257 46.3416 33.8799 46.2078C34.2458 46.0731 34.625 46.0119 35.0154 46.0243C36.5538 46.0243 37.5551 47.0012 38.019 48.4298L48.0312 77.7214L58.1409 48.3565C58.6052 46.989 59.5451 46.0243 61.0713 46.0243H61.3885C62.0964 46.0155 62.7805 46.2442 63.3421 46.6713C63.9039 47.0868 64.2944 47.6847 64.4653 48.3562L74.4776 77.7212L84.6606 48.2708C84.8068 47.6355 85.1612 47.0619 85.674 46.6468C86.1994 46.2312 86.8462 46.0115 87.5056 46C87.8839 46 88.2622 46.0621 88.6166 46.1959C88.971 46.3182 89.2882 46.5255 89.5568 46.7816C89.8377 47.0261 90.045 47.3309 90.2036 47.6728C90.3498 48.0148 90.4357 48.3807 90.4481 48.7472C90.4038 49.2842 90.2771 49.8096 90.0698 50.3224L77.8721 83.3625C77.2617 85.0963 76.0284 85.9999 74.6364 85.9999H74.4043C72.8659 85.9999 71.7059 85.0963 71.1687 83.3625L61.2297 54.9256L51.1932 83.3625C50.6563 85.0963 49.5082 85.9999 47.9576 85.9999H47.8114C46.3462 86.0088 45.1012 85.1085 44.4907 83.3625Z",
    fill: "#003AA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4793 85.8043C97.9336 85.8043 99.9238 83.8507 99.9238 81.4454C99.9238 79.0522 97.9336 77.0985 95.4793 77.0985C93.0251 77.0985 91.035 79.0522 91.035 81.4454C91.035 83.8507 93.0251 85.8043 95.4793 85.8043Z",
    fill: "#E60030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_14",
    x: 0,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160156 0 0 0 0 0.211953 0 0 0 0 0.3125 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconWeb);
export default __webpack_public_path__ + "static/media/modal-icon-web.1d83fc47ec47b9ee7c607cab1b247acf.svg";
export { ForwardRef as ReactComponent };